import { JobMatchAction } from "../../models/jobMatchAction";
var ReviewCandidatePullFromJobBoardsController = /** @class */ (function () {
    /*@ngInject*/
    function ReviewCandidatePullFromJobBoardsController($rootScope, $filter, $timeout, $uibModal, jobService, jobMatchService, jobMatchActionsService, modalService, alertsAndNotificationsService, notificationsService) {
        this.$rootScope = $rootScope;
        this.$filter = $filter;
        this.$timeout = $timeout;
        this.$uibModal = $uibModal;
        this.jobService = jobService;
        this.jobMatchService = jobMatchService;
        this.jobMatchActionsService = jobMatchActionsService;
        this.modalService = modalService;
        this.alertsAndNotificationsService = alertsAndNotificationsService;
        this.notificationsService = notificationsService;
    }
    ReviewCandidatePullFromJobBoardsController.prototype.$onInit = function () {
        // variables
        // initialize uploaded candidate count to zero
        this.candidateCounts = {
            uploadedCandidateCount: 0,
            notProcessedCandidateCount: 0,
            autoMatchedCandidateCount: 0,
            unmatchedCandidateCount: 0,
            manuallyMatchedCandidateCount: 0,
            updatedCandidateCount: 0
        };
        this.candidatesList = [];
        this.candidatesToAssociateList = [];
        this.createJobMatchesObject = {};
        // flags
        // this.loadingCountsInfoFlag = false;
        // this.loadingJobMatchesInfoFlag = false;
        this.selectedAllCandidatesFlag = false;
        this.associatingCandidatesFlag = false;
        this.createJobMatchesObject = {
            companyId: this.$rootScope.userDetails.company.companyId,
            requisitionId: this.jobId,
            candidateIds: [],
            manuallyMatchedFromUI: true,
            jbiTransactionId: this.jbiTransactionId,
            isAddCandidate: false,
            isAssociateCandidate: false,
            overrideNoteDetails: []
        };
        // this.getJobBoardPullCounts(() => {
        //     this.getJobBoardPullMatchInfo();
        // });
        // this.getAllActivityTypes();
        if (this.candidateDtoMap) {
            this.jobBoarPulledCandidates = JSON.parse(this.candidateDtoMap);
            this.candidatesList = this.jobBoarPulledCandidates.candidates;
        }
        this._setDetails();
    };
    ReviewCandidatePullFromJobBoardsController.prototype._setDetails = function () {
        var jobId = null;
        if (this.jobId !== '' && this.jobId !== undefined && this.jobId !== null) {
            jobId = this.jobId;
        }
        this._massageCandidateDetails();
        this._getCandidateCounts();
        this.getAllActivityTypes();
        this.setCandidateCount();
    };
    ReviewCandidatePullFromJobBoardsController.prototype._getCandidateCounts = function () {
        this.displaySelectDeselectButtonFlag = (this.jobBoarPulledCandidates && this.jobBoarPulledCandidates.create && this.jobBoarPulledCandidates.create.unMatchedCandidateCount !== 0) || (this.jobBoarPulledCandidates && this.jobBoarPulledCandidates.update && this.jobBoarPulledCandidates.update.unMatchedCandidateCount !== 0);
    };
    ReviewCandidatePullFromJobBoardsController.prototype._massageCandidateDetails = function () {
        var _this = this;
        angular.forEach(this.candidatesList, function (val, key) {
            if (_.isNull(val.firstName)) {
                val.firstName = "-";
            }
            if (_.isNull(val.lastName)) {
                val.lastName = "-";
            }
            if (_.isNull(val.email)) {
                val.email = "-";
            }
            if (_.isNull(val.phone)) {
                val.phone = "-";
            }
            val.name = val.firstName + ' ' + val.lastName;
            if (val.mobilePhoneCountryCodePresent) {
                var phoneNumberObject = libphonenumber.parse(val.phone.toString());
                if (phoneNumberObject.phone !== undefined) {
                    val.phone = libphonenumber.format(phoneNumberObject.phone, phoneNumberObject.country, 'International');
                }
            }
            // floor the match score to the lower integer value.
            val.score = Math.floor(parseFloat(val.score));
            val.selectedFlag = false;
            if (val.score >= val.jobThresholdScore) {
                val.intelligenceScorePassFlag = true;
            }
            var createdCandidateMatchedToJob = false;
            var updatedCandidateMatchedToJob = false;
            if (_this.jobBoarPulledCandidates.create) {
                createdCandidateMatchedToJob = !_this.jobBoarPulledCandidates.create.unMatchedCandidateIdAndNames.map(function (can) { return can.candidateId; }).includes(val.candidateId);
            }
            if (_this.jobBoarPulledCandidates.update) {
                updatedCandidateMatchedToJob = !_this.jobBoarPulledCandidates.update.unMatchedCandidateIdAndNames.map(function (can) { return can.candidateId; }).includes(val.candidateId);
            }
            val.candidateMatchedToJob = createdCandidateMatchedToJob || updatedCandidateMatchedToJob;
            if (val.candidateMatchedToJob) {
                val.allowManualMatch = false;
            }
            if ((val.score < val.jobThresholdScore) && val.statusOfJobMatch === 'The candidate details updated for job.') {
                val.isCandidateDetailsUpdatedForJob = true;
            }
        });
    };
    ReviewCandidatePullFromJobBoardsController.prototype.setCandidateCount = function () {
        if (this.jobBoarPulledCandidates) {
            this.candidateCounts = {
                uploadedCandidateCount: this.jobBoarPulledCandidates.uploadedCandidatesCount ? this.jobBoarPulledCandidates.uploadedCandidatesCount : 0,
                notProcessedCandidateCount: this.jobBoarPulledCandidates.create.notProcessedCandidateCount ? this.jobBoarPulledCandidates.create.notProcessedCandidateCount : 0,
                autoMatchedCandidateCount: this.jobBoarPulledCandidates.create.matchedCandidateCount ? this.jobBoarPulledCandidates.create.matchedCandidateCount : 0,
                unmatchedCandidateCount: this.jobBoarPulledCandidates.create.unMatchedCandidateCount ? this.jobBoarPulledCandidates.create.unMatchedCandidateCount : 0,
                manuallyMatchedCandidateCount: this.jobBoarPulledCandidates.create.manuallyMatchedCandidateCount ? this.jobBoarPulledCandidates.create.manuallyMatchedCandidateCount : 0,
                updatedCandidateCount: this.jobBoarPulledCandidates.create.updatedCandidateCount ? this.jobBoarPulledCandidates.create.updatedCandidateCount : 0
            };
        }
    };
    // getJobBoardPullCounts(successCallback) {
    //     this.loadingCountsInfoFlag = true;
    //     this.jobService.getJobBoardPullCounts(this.jobId, this.jbiTransactionId, (data) => {
    //         this.candidateCounts = data;
    //         this.loadingCountsInfoFlag = false;
    //         if(successCallback) {
    //             successCallback();
    //         }
    //     }, (error) => {
    //         this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
    //     });
    // }
    // getJobBoardPullMatchInfo() {
    //     this.loadingJobMatchesInfoFlag = true;
    //     this.jobService.getJobBoardPullMatchInfo(this.jbiTransactionId, (data) => {
    //         angular.forEach(data, (val, key) => {
    //             if(_.isNull(val.firstName)) {
    //                 val.firstName = "-";
    //             }
    //             if(_.isNull(val.lastName)) {
    //                 val.lastName = "-";
    //             }
    //             if(_.isNull(val.email)) {
    //                 val.email = "-";
    //             }
    //             if(_.isNull(val.phone)) {
    //                 val.phone = "-";
    //             }
    //             val.name = val.firstName + ' ' + val.lastName;
    //             // floor the match score to the lower integer value.
    //             val.score = Math.floor(parseFloat(val.score));
    //             if(val.score >= val.jobThresholdScore) {
    //                 val.intelligenceScorePassFlag = true;
    //             }
    //             val.selectedFlag = false;
    //             this.candidatesList.push(val);
    //         });
    //         this.loadingJobMatchesInfoFlag = false;
    //     }, (error) => {
    //         this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
    //     })
    // }
    ReviewCandidatePullFromJobBoardsController.prototype.toggleSelectAllCandidates = function () {
        var _this = this;
        if (this.selectedAllCandidatesFlag) {
            // if selectAllCandidates was already selected, remove all selections
            angular.forEach(this.candidatesList, function (val, key) {
                // if candidate was not already added successfully and was selected, de select it and remove it from associate list
                if (!val.candidateMatchedToJob && val.selectedFlag && val.allowManualMatch) {
                    val.selectedFlag = false;
                    // if selected is removed, remove from candidates to associate list
                    _.remove(_this.candidatesToAssociateList, {
                        candidateId: val.candidateId
                    });
                }
            });
            this.selectedAllCandidatesFlag = false;
        }
        else {
            // if selectAllCandidates was not already selected
            angular.forEach(this.candidatesList, function (val, key) {
                // if candidate was not already added successfully and also not already selected, select it and add to associate list
                if (!val.candidateMatchedToJob && !val.selectedFlag && val.allowManualMatch) {
                    val.selectedFlag = true;
                    _this.candidatesToAssociateList.push(val);
                }
            });
            this.selectedAllCandidatesFlag = true;
        }
    };
    ReviewCandidatePullFromJobBoardsController.prototype.candidateToAssociateToggle = function (candidate) {
        // if it is selected, add to associate list
        if (candidate.selectedFlag) {
            this.candidatesToAssociateList.push(candidate);
        }
        else {
            // if selected is removed, remove from candidates to associate list
            _.remove(this.candidatesToAssociateList, {
                candidateId: candidate.candidateId
            });
            _.remove(this.createJobMatchesObject.overrideNoteDetails, {
                candidateId: candidate.candidateId
            });
        }
    };
    ReviewCandidatePullFromJobBoardsController.prototype.associateCandidates = function () {
        var _this = this;
        angular.forEach(this.candidatesToAssociateList, function (val, key) {
            _this.createJobMatchesObject.candidateIds.push(val.candidateId);
        });
        this.associatingCandidatesFlag = true;
        var associatingDialog = bootbox.dialog({
            message: '<p class="text-center">Adding Candidates <i class="fa fa-spinner fa-spin"></i></p>',
            closeButton: false
        });
        this.jobMatchService.createJobMatches(this.createJobMatchesObject, function (data) {
            _this.associatingCandidatesFlag = false;
            associatingDialog.modal('hide');
            _this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
            angular.forEach(_this.candidatesToAssociateList, function (val, key) {
                // find each associated candidate in the original candidates list
                var index = _.findIndex(_this.candidatesList, {
                    candidateId: val.candidateId
                });
                // for each candidate, set the added successfully flag to true and selected flag to false
                _this.candidatesList[index].candidateMatchedToJob = true;
                _this.candidatesList[index].statusOfJobMatch = "Candidate 'manually' added to the job.";
                _this.candidatesList[index].selectedFlag = false;
                _this.candidatesList[index].jobMatchManuallyCreated = true;
                // update notification payload
                if (_this.jobBoarPulledCandidates.update) {
                    if (_this.jobBoarPulledCandidates.update.unMatchedCandidateIdAndNames && _this.jobBoarPulledCandidates.update.unMatchedCandidateIdAndNames.length > 0) {
                        _this.jobBoarPulledCandidates.update.unMatchedCandidateIdAndNames.forEach(function (candidate) {
                            if (candidate.candidateId == val.candidateId) {
                                _this.jobBoarPulledCandidates.update.unMatchedCandidateCount--;
                                _this.jobBoarPulledCandidates.update.matchedCandidateCount++;
                                _this.jobBoarPulledCandidates.update.matchedCandidateIdAndNames.push(candidate);
                                _.remove(_this.jobBoarPulledCandidates.update.unMatchedCandidateIdAndNames, {
                                    candidateId: val.candidateId
                                });
                            }
                        });
                    }
                }
                if (_this.jobBoarPulledCandidates.create) {
                    if (_this.jobBoarPulledCandidates.create.unMatchedCandidateIdAndNames && _this.jobBoarPulledCandidates.create.unMatchedCandidateIdAndNames.length > 0) {
                        _this.jobBoarPulledCandidates.create.unMatchedCandidateIdAndNames.forEach(function (candidate) {
                            if (candidate.candidateId == val.candidateId) {
                                _this.jobBoarPulledCandidates.create.unMatchedCandidateCount--;
                                _this.jobBoarPulledCandidates.create.manuallyMatchedCandidateCount++;
                                _this.jobBoarPulledCandidates.create.manuallyMatchedCandidateIdAndNames.push(candidate);
                                _.remove(_this.jobBoarPulledCandidates.create.unMatchedCandidateIdAndNames, {
                                    candidateId: val.candidateId
                                });
                            }
                        });
                    }
                }
            });
            _this.jobBoarPulledCandidates.candidates = JSON.parse(angular.toJson(_this.candidatesList));
            // make the candidates to associate list as empty.
            _this.candidatesToAssociateList = [];
            // reload the counts to refresh manually added candidates counts
            _this._getCandidateCounts();
            _this.alertsAndNotificationsService.showBannerMessage("Candidates have been successfully added to the job", "success");
            _this.$rootScope.$broadcast('refreshJobWorkflow', null);
            //save api
            if (_this.notificationId) {
                _this.notificationsService.saveCandidateResumeNotification(_this.notificationId, _this.jobBoarPulledCandidates, function (data) {
                    // Do Nothing
                }, function (error) {
                    _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                });
            }
            if (_this.closeCallback) {
                _this.closeCallback();
            }
        }, function (error) {
            _this.associatingCandidatesFlag = false;
            _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    };
    ReviewCandidatePullFromJobBoardsController.prototype.showOverrideCandidateSuspensionModal = function (candidate) {
        var _this = this;
        var candidateId = candidate.candidateId;
        var candidateName = candidate.name;
        var suspendedMonths = candidate.overrideFor === "RELEASE" ? candidate.releasedCandidateDetailDTO.numberOfMonthsToWait : candidate.jobLeftCandidateDetailDTO.numberOfMonthsToWait;
        var releaseDate = candidate.overrideFor === "RELEASE" ? candidate.releasedCandidateDetailDTO.releasedAt : candidate.jobLeftCandidateDetailDTO.leftAt;
        var allowOverride = candidate.allowOverride;
        var releasedJobDetails = candidate.overrideFor === "RELEASE" ? candidate.releasedCandidateDetailDTO : candidate.jobLeftCandidateDetailDTO;
        var type = candidate.overrideFor === "RELEASE" ? "release" : "jobLeft";
        if (allowOverride) {
            var warningModal = this.$uibModal.open({
                animation: false,
                ariaLabelledBy: 'modal-title',
                ariaDescribedBy: 'modal-body',
                backdrop: 'static',
                windowClass: 'four-dot-five-modal-medium',
                component: 'uploadResumesActionsModal',
                resolve: {
                    candidateId: function () {
                        return candidateId;
                    },
                    candidateName: function () {
                        return candidateName;
                    },
                    suspendedMonths: function () {
                        return suspendedMonths;
                    },
                    releaseDate: function () {
                        return releaseDate;
                    },
                    allowOverride: function () {
                        return allowOverride;
                    },
                    releasedJobDetails: function () {
                        return releasedJobDetails;
                    },
                    type: function () {
                        return type;
                    }
                }
            });
            warningModal.result.then(function (callbackObject) {
                if (callbackObject.callbackType == 'save') {
                    var index = _.findIndex(_this.candidatesList, {
                        candidateId: candidate.candidateId
                    });
                    _this.createJobMatchesObject.overrideNoteDetails.push(ctrl.recruiterDetails);
                    _this.candidatesList[index].allowManualMatch = true;
                    _this.candidatesList[index].showOverride = false;
                    _this.candidatesList[index].candidateMatchedToJob = false;
                    _this.candidatesList[index].statusOfJobMatch = 'Candidate is made available for matching.';
                    _this.candidatesList[index].selectedFlag = true;
                    _this.candidateToAssociateToggle(_this.candidatesList[index]);
                }
            }, function (dismiss) {
                //do nothing
            });
        }
        else {
            var displayHtmlText = "";
            if (type == 'release') {
                displayHtmlText = "Candidate '<span class='emerald'>" + candidateName + "</span>' cannot apply for any position as it is within '<span class='emerald'>" + suspendedMonths + "</span>' month(s) of candidate's previous release. ";
                displayHtmlText = displayHtmlText + "Candidate was previously released on '<span class='emerald'>" + this.$filter('fourdotfiveDateFormat')(releaseDate) + "</span>' from the role '<span class='emerald'>" + releasedJobDetails.role + "</span>' ";
                displayHtmlText = displayHtmlText + "with Requisition Number '<span class='emerald'>" + releasedJobDetails.requisitionNumber + "</span>'.";
            }
            else {
                displayHtmlText = "Candidate <span class='emerald'>'" + candidateName + "'</span> cannot apply for any position as it is within '<span class='emerald'>" + suspendedMonths + "</span>' month(s) of leaving previous job. ";
                displayHtmlText = displayHtmlText + "Candidate left previous job on '<span class='emerald'>" + this.$filter('fourdotfiveDateFormat')(releaseDate) + "</span>' from the role '<span class='emerald'>" + releasedJobDetails.role + "</span>' ";
                displayHtmlText = displayHtmlText + "with Requisition Number '<span class='emerald'>" + releasedJobDetails.requisitionNumber + "</span>'.";
            }
            bootbox.alert({
                closeButton: false,
                title: "<div class='alert alert-warning' style='margin-bottom: 0px;'><i class='fas fa-exclamation-triangle fa-fw fa-lg'></i><strong>Cannot add candidate</strong></div>",
                message: displayHtmlText,
                className: "zIndex1060",
                buttons: {
                    ok: {
                        label: 'Ok',
                        className: 'btn-info'
                    }
                },
                callback: function () {
                    _this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
                }
            });
        }
    };
    ReviewCandidatePullFromJobBoardsController.prototype.jobCompare = function (candidate) {
        var actionObject = new JobMatchAction("Candidate Job Comparison", "CANDIDATE_JOB_COMPARE", true, null);
        candidate.jobMatchJobId = this.jobId;
        candidate.id = candidate.candidateId;
        this.jobMatchActionsService.performAction('reviewCandidatePull', actionObject, candidate, function () {
        }, function () {
        });
    };
    ReviewCandidatePullFromJobBoardsController.prototype.displayProcessedCandidates = function (activity) {
        var _this = this;
        $(".modal").addClass("upload-resumes-modal-medium");
        this.$timeout(function () {
            var displayCandidatesModal = _this.$uibModal.open({
                animation: true,
                ariaLabelledBy: 'modal-title',
                ariaDescribedBy: 'modal-body',
                backdrop: 'static',
                component: 'uploadResumesTransactionCandidatesModal',
                windowTopClass: 'four-dot-five-modal-large',
                resolve: {
                    jobBoarPulledCandidatesObject: function () {
                        return _this.jobBoarPulledCandidates;
                    },
                    activity: function () {
                        return activity;
                    },
                    modalType: function () {
                        return "jobBoardPull";
                    },
                    activityMap: function () {
                        return _this.activityMap;
                    }
                }
            });
            displayCandidatesModal.result.then(function () {
                _this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
            }, function () {
                _this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
            });
        }, 300);
    };
    ReviewCandidatePullFromJobBoardsController.prototype.getAllActivityTypes = function () {
        var _this = this;
        this.activityMap = [];
        this.jobService.getActivityTypes(function (data) {
            angular.forEach(data, function (val, key) {
                _this.activityMap[val.value] = val.name;
            });
        }, function (error) {
            if (_this.$rootScope.isOnline) {
                _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
        });
    };
    return ReviewCandidatePullFromJobBoardsController;
}());
ReviewCandidatePullFromJobBoardsController.$inject = ['$rootScope', '$filter', '$timeout', '$uibModal', 'jobService', 'jobMatchService', 'jobMatchActionsService', 'modalService', 'alertsAndNotificationsService', 'notificationsService'];
// import * as TEMPLATE from './review-candidate-pull-from-job-boards.html';
import * as TEMPLATE from 'raw-loader!./review-candidate-pull-from-job-boards.html';
export var ReviewCandidatePullFromJobBoardsComponent = {
    selector: 'reviewCandidatePullFromJobBoards',
    component: {
        bindings: {
            jbiTransactionId: '@',
            jobId: '@',
            reviewHtmlText: '@',
            candidateDtoMap: '@',
            notificationId: '@',
            closeCallback: '&'
        },
        controller: ReviewCandidatePullFromJobBoardsController,
        template: TEMPLATE.default
        // templateUrl: 'app/components/reviewCandidatePullFromJobBoards/review-candidate-pull-from-job-boards.html'
    }
};
//# sourceMappingURL=review-candidate-pull-from-job-boards.component.js.map